export var ESpeechCategory;
(function (ESpeechCategory) {
    ESpeechCategory["Overall"] = "Overall";
    ESpeechCategory["Pronunciation"] = "Pronunciation";
    ESpeechCategory["Fluency"] = "Fluency";
    ESpeechCategory["Vocabulary"] = "Vocabulary";
    ESpeechCategory["Grammar"] = "Grammar";
})(ESpeechCategory || (ESpeechCategory = {}));
export var ERubric;
(function (ERubric) {
    ERubric["SkillIQ"] = "Skill IQ";
    ERubric["CEFR"] = "CEFR";
    ERubric["PTE"] = "PTE";
    ERubric["IELTS"] = "IELTS";
    ERubric["TOEFL"] = "TOEFL";
    ERubric["TOEIC"] = "TOEIC";
})(ERubric || (ERubric = {}));
